import { env } from "@/env";

export function getAppEnv() {
  if (typeof window !== undefined) {
    // On client side, use VITE_APP_ENV
    try {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      return env.VITE_APP_ENV;
    } catch {
      return "development";
    }
  } else {
    // On server side, use APP_ENV
    try {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      return env.APP_ENV;
    } catch {
      return "development";
    }
  }
}

export function isProductionEnvironment() {
  return getAppEnv() === "production";
}

export function isTestEnvironment() {
  return getAppEnv() === "test";
}

export function isPreviewEnvironment() {
  return getAppEnv() === "preview";
}

export function isDevelopment() {
  return getAppEnv() === "development";
}
